import { rest } from 'msw';
import { getConfig } from 'shared/config';
import { deleteAddonProductsMock, getAddonProductsMock, postAddonProductsMock } from '.';

export const handlers = [
  rest.get(
    `${getConfig().odin?.host}/yousee/selfcare/subscriptions/:subscriptionId/addonproducts`,
    (req, res, ctx) => {
      return res(ctx.json(getAddonProductsMock));
    },
  ),
  rest.post(
    `${getConfig().odin?.host}/yousee/selfcare/subscriptions/:subscriptionId/addonproducts`,
    (req, res, ctx) => {
      return res(ctx.json(postAddonProductsMock));
    },
  ),
  rest.delete(
    `${getConfig().odin?.host}/yousee/selfcare/subscriptions/:subscriptionId/addonproducts`,
    (req, res, ctx) => {
      return res(ctx.json(deleteAddonProductsMock));
    },
  ),
];
